import { AliasDetail, OrganisationAliasesDetail, TradingEntityMeta, TradingEntityMetaUpdate } from 'api'
import { sortBy } from 'lodash'
import { createSelector, Selector } from '@reduxjs/toolkit'
import { tradingEntityMetaStoreSelector } from 'selectors/storeSelectors'
import { GlobalState } from 'store'
import { RepositoryEntry } from 'store/repository'
import { tradingEntityMetasContainingAliasesSelector } from './tradingEntityMetaSelectors'
import { tradingEntityGetterSelector } from './tradingEntitySelectors'

export const aliasesDetailsGetterSelector: Selector<
  GlobalState,
  (tradingEntityMetas: TradingEntityMeta[]) => AliasDetail[]
> = createSelector(tradingEntityGetterSelector, getTradingEntity => (tradingEntityMetas: TradingEntityMeta[]) => {
  const aliasesDetails = tradingEntityMetas.flatMap(meta => {
    const ownerTradingEntity = getTradingEntity(meta.ownerTradingEntityId)
    const subjectTradingEntity = getTradingEntity(meta.subjectTradingEntityId)

    if (!ownerTradingEntity || !subjectTradingEntity) return []

    return meta.aliasTypeAndValues.map((aliasTypeAndValue, aliasIdx) => ({
      id: `${meta.id},${aliasIdx}`,
      index: aliasIdx,
      aliasTypeAndValue,
      metaId: meta.id,
      ownerTradingEntity,
      subjectTradingEntity
    }))
  })

  return sortBy(
    aliasesDetails,
    detail => detail.ownerTradingEntity.publishedName,
    detail => detail.subjectTradingEntity.publishedName,
    detail => detail.aliasTypeAndValue.value
  )
})

export const organisationAliasesDetailSelector: Selector<GlobalState, OrganisationAliasesDetail[]> = createSelector(
  tradingEntityMetaStoreSelector,
  tradingEntityMetasContainingAliasesSelector,
  aliasesDetailsGetterSelector,
  (allMetaEntries, tradingEntityMetas, getAliasesDetails) => {
    const aliasesDetails = getAliasesDetails(tradingEntityMetas).map(alias => {
      const entry: RepositoryEntry<TradingEntityMetaUpdate> | undefined = allMetaEntries[alias.metaId]

      return { ...alias, availableEvents: entry.lastUpdate.availableEvents ?? [] }
    })

    return aliasesDetails
  }
)
